import { Eye, Pencil } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ViewToggleProps {
  /** Whether the preview view is active. */
  isPreview: boolean;
  /** Switches between the Edit and Preview views. */
  onChange: (isPreview: boolean) => void;
}

/**
 * Edit/Preview segmented control for the document tab header. Preview renders
 * the document through the identical customer-facing pipeline with all editor
 * chrome unmounted.
 * @param isPreview - Whether the preview view is active
 * @param onChange - Switches between the Edit and Preview views
 */
export function ViewToggle({ isPreview, onChange }: ViewToggleProps) {
  return (
    <div className="flex items-center gap-0.5 rounded-md border p-0.5">
      <Button
        variant={isPreview ? "ghost" : "secondary"}
        size="sm"
        className="h-7"
        onClick={() => onChange(false)}
      >
        <Pencil className="size-4" /> Edit
      </Button>
      <Button
        variant={isPreview ? "secondary" : "ghost"}
        size="sm"
        className="h-7"
        onClick={() => onChange(true)}
      >
        <Eye className="size-4" /> Preview
      </Button>
    </div>
  );
}
